module.exports = __webpack_public_path__ + "img/desconto_extra.e95466c1.jpg";